module.exports = __webpack_public_path__ + "img/yelp_logo.7a583061.png";